// Copyright 2025-2026 - Hewlett Packard Enterprise Company
import { useContext, useMemo } from 'react';
import { Grommet } from 'grommet';
import { deepMerge, normalizeColor } from 'grommet/utils';
import { hpe as v8 } from 'grommet-theme-hpe';
import { hpe as v7 } from 'theme-v7';

import useFlags from './hooks/useFlags';
import { ThemeModeContext } from './providers/ThemeModeProvider';

const versionMap = {
  7: v7,
  8: v8,
};

export default function ThemedApp({ children }) {
  const { themeMode } = useContext(ThemeModeContext);

  const flags = useFlags();
  const themeVersion = flags.T_20260429_69543_THEME_VERSION();

  const theme = useMemo(() => {
    const resolvedHpeTheme = versionMap[themeVersion] ?? v7;

    // in theme v6 the background-back color was made gray and cards use contrast
    // instead of elevation to achieve visual separation. It's anticipated that
    // v9 grommet theme hpe will return to a white background-back color, so manually
    // swapping the colors for now
    const swappedBackgrounds = {
      global: {
        colors: {
          'background-back': {
            light: normalizeColor('background-front', resolvedHpeTheme, false),
            dark: normalizeColor('background-front', resolvedHpeTheme, true),
          },
          'background-front': {
            light: normalizeColor('background-back', resolvedHpeTheme, false),
            dark: normalizeColor('background-back', resolvedHpeTheme, true),
          },
        },
      },
    };

    return deepMerge(resolvedHpeTheme, swappedBackgrounds);
  }, [themeVersion]);

  return (
    <Grommet theme={theme} themeMode={themeMode} background={'background-back'}>
      {children}
    </Grommet>
  );
}
